"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getByFormatText = exports.getActionsCount = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var getActionsCount = exports.getActionsCount = function getActionsCount(hasLeftContent, hasRightContent) {
  if (hasLeftContent && hasRightContent) {
    return 2;
  }
  return !hasLeftContent && !hasRightContent ? 0 : 1;
};
var getByFormatText = exports.getByFormatText = function getByFormatText(text) {
  return typeof text === 'string' ? text : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, text);
};